import { defineMessages } from 'react-intl'

export default defineMessages({
  owner: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.owner',
    defaultMessage: 'Account Owner',
  },
  ownerAlert: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.ownerAlert',
    defaultMessage: 'The company has successfully been sychronized to the finance account connected to the selected company \"owner\" beneath. If you need to move the company to another finance account, please contact the VoiceArchive finance team.',
  },
  ownerAlertFinance: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.ownerAlertFinance',
    defaultMessage: 'The company is invoiced by the account owner selected beneath. Changing it moves the company, and its contacts, to another finance account: the e-conomic id is cleared and the customer has to be re-created in the new owner\'s e-conomic agreement. Orders that are already open keep the owner they were created under.',
  },
  why: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.why',
    defaultMessage: 'Why?',
  },
  economicDebtorGroup: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.economicDebtorGroup',
    defaultMessage: 'Economic debtor group',
  },
  ownerConfirm: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.ownerConfirm',
    defaultMessage: 'Move {customerName} from {from} to {to}?',
  },
  ownerConfirmEconomic: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.ownerConfirmEconomic',
    defaultMessage: 'The e-conomic id ({economicId}) will be cleared and kept in the notes.',
  },
  ownerConfirmNoEconomic: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.ownerConfirmNoEconomic',
    defaultMessage: 'The company has no e-conomic id yet.',
  },
  ownerConfirmOrders: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.ownerConfirmOrders',
    defaultMessage: '{count, plural, one {# open order keeps} other {# open orders keep}} the current owner.',
  },
  ownerConfirmContacts: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.ownerConfirmContacts',
    defaultMessage: 'The company contacts move with it.',
  },
  ownerSaving: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.ownerSaving',
    defaultMessage: 'Moving…',
  },
  ownerFailed: {
    id: 'containers.EmbeddedCompanyPage.components.FinanceTerms.ownerFailed',
    defaultMessage: 'The account owner could not be changed: {error}',
  },
})
